export const isJest = () => typeof jest !== "undefined";
//# sourceMappingURL=isJest.js.map